import React from 'react';
import { ChevronRight, Home } from 'lucide-react';

const Breadcrumb = ({ path, onNavigate }) => {
  const pathSegments = path ? path.split('/').filter(Boolean) : [];

  const handleSegmentClick = (index) => {
    if (index === -1) {
      // Root clicked
      onNavigate('');
    } else {
      // Build path up to clicked segment
      const newPath = pathSegments.slice(0, index + 1).join('/');
      onNavigate(newPath);
    }
  };

  return (
    <nav className="flex items-center space-x-2 text-sm text-gray-600 mb-4">
      <button
        onClick={() => handleSegmentClick(-1)}
        className="flex items-center space-x-1 hover:text-gray-900 transition-colors"
      >
        <Home className="h-4 w-4" />
        <span>Gyökér</span>
      </button>
      
      {pathSegments.map((segment, index) => (
        <React.Fragment key={index}>
          <ChevronRight className="h-4 w-4 text-gray-400" />
          <button
            onClick={() => handleSegmentClick(index)}
            className="hover:text-gray-900 transition-colors truncate max-w-xs"
            title={segment}
          >
            {segment}
          </button>
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb; 